<template>
  <div :class="classList">
    <label>{{ label }}</label>
    <div v-if="description" class="description">{{ description }}</div>
    <input
      ref="input"
      type="text"
      class="form-control"
      v-model="inputVal"
      :maxlength="maxLength"
      :placeholder="placeholder"
      @input="handleOnInput()"
    />
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      This field is required.
    </p>
    <p class="required-message" v-if="submitClicked && validationErrorMessage">
      {{ validationErrorMessage }}
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a textbox
Any error of textbox (for example: required field, invalid character, exceed length ...) is showed in this component */
import { TEXTBOX_INPUT_TYPE } from "../../constants/custom-define-type";
import { REGEX_VALID_NUMBER } from "../../constants/regex";

export default {
  name: "TextBoxWithLabel",
  props: {
    /* Name of the textbox component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // Type of input: text or number
    type: {
      type: String,
      default: TEXTBOX_INPUT_TYPE.TEXT
    },
    // Validation for input
    validation: {
      type: Array,
      default: () => []
    },
    placeholder: String,
    // Max length of input
    maxLength: {
      type: Number
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    }
  },
  // created() {
  //   this.$emit("input", this.label);
  // },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    validationErrorMessage() {
      if (!this.inputVal) {
        return;
      }
      for (const validateItem of this.validation) {
        if (validateItem.regex) {
          if (!validateItem.regex.test(this.inputVal)) {
            return validateItem.message;
          }
        }
      }
    }
  },
  methods: {
    handleOnInput() {
      if (this.type && REGEX_VALID_NUMBER[this.type]) {
        const oldVal = this.inputVal;
        this.$nextTick(() => {
          if (!REGEX_VALID_NUMBER[this.type].test(this.inputVal)) {
            this.inputVal = oldVal;
            this.$refs.input.blur();
            setTimeout(() => {
              this.$refs.input.focus();
            });
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/TextBoxWithLabel.vue